import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CONVERSATION_STATUSES, CONVERSATION_TYPES } from "../constants";
import type { ConversationChannelFilterOptions } from "../types/ConversationChannelFilterOptions";
import type { ConversationStatusFilterOptions } from "../types/ConversationStatusFilterOptions";
import { FilterDropdown } from "./common/FilterDropdown";

interface Filters {
  status: ConversationStatusFilterOptions;
  type: ConversationChannelFilterOptions;
}

export const ConversationFilters = ({
  onFiltersChange,
}: {
  onFiltersChange: (filters: Filters) => void;
}) => {
  const { setValue } = useFormContext();
  const [type, status] = useWatch<Filters, ["type", "status"]>({
    name: ["type", "status"],
  });

  useEffect(() => {
    onFiltersChange({ type, status });
  }, [type, status, onFiltersChange]);

  const handleTypeChange = (value: string) => {
    setValue("type", value);
  };

  const handleStatusChange = (value: string) => {
    setValue("status", value);
  };

  return (
    <div className="w-full px-4 py-2">
      <div className="flex gap-2">
        <div className="w-1/2">
          <FilterDropdown
            activeItem={type || "all"}
            data={CONVERSATION_TYPES}
            onItemClick={handleTypeChange}
            dataTestId="conversation-type-filter"
          />
        </div>
        <div className="w-1/2">
          <FilterDropdown
            activeItem={status || "all"}
            data={CONVERSATION_STATUSES}
            onItemClick={handleStatusChange}
            dataTestId="conversation-status-filter"
          />
        </div>
      </div>
    </div>
  );
};
